$(function() {
	const $doc = $(document);

	$doc.on('blur', '[name="date"], [name="time_period"], [name="memo"]', setNoteValue);
	$doc.on('change', '[name="date"], [name="time_period"], [name="memo"]', setNoteValue);

	initCart();
})

/**
 * トップページ初期化処理
 */
function initCart() {
	initUserRequestDate();
	setNoteValue();
}

/**
 * 「お届け希望日」フィールドを初期化
 */
function initUserRequestDate() {
    let minDate = new Date();
    let maxDate = new Date();

    // 最短3日後の日付をセット
    minDate.setDate(minDate.getDate() + 3);

    // 最大14日後の日付をセット
    maxDate.setDate(maxDate.getDate() + 14);

    // プルダウンを生成
    const selectDate = $('#userRequestDate');
    selectDate.append($('<option>').text('指定なし'));

    while (minDate <= maxDate) {
        const formattedDate = formatDate(minDate);
        selectDate.append($('<option>').val(formattedDate).text(formattedDate));
        minDate.setDate(minDate.getDate() + 1);
    }

    function formatDate(date) {
        const y = date.getFullYear();
        const m = ('0' + (date.getMonth() + 1)).slice(-2);
        const d = ('0' + date.getDate()).slice(-2);
		const weekdays = { weekday: 'short', timeZone: 'Asia/Tokyo' };
		const w = date.toLocaleString('ja-JP', weekdays);
        return `${y}年${m}月${d}日(${w})`;
    }
}

/**
 * 隠し要素[name="note"]に値をセット
 */
function setNoteValue() {
	const date = $('[name="date"]').val();
	const timePeriod = $('[name="time_period"] :selected').val();
	const memo = $('[name="memo"]').val();

	const strArray = [];
	// お届け希望日
	const dateStr = date === ''? '指定なし': date;
	strArray.push('【お届け希望日】' + dateStr);
	// お届け希望時間帯
	strArray.push('【お届け希望時間帯】' + timePeriod);
	// 要望
	const memoStr = memo === ''? 'なし': memo;
	strArray.push('【要望】' + memoStr);

	// 追加情報を１つの文字列に結合
	const noteVal = strArray.join("\n");

	// 隠しフォームパーツに値をセット
	$('[name="note"]').val(noteVal);
}